import { useHistory, useLocation } from "react-router-dom";

import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_ORDERS_URL, CMP_STOCK_URL, getCmpUrl } from "@/core/urls";
import SegmentedControl from "@/tpo/SegmentedControl";

export default function Switcher() {
  const history = useHistory();
  const location = useLocation();
  const { organisation } = useOrganisationContext();

  return (
    <SegmentedControl
      data={[
        {
          label: "direct",
          value: getCmpUrl(CMP_ORDERS_URL, {
            organisationId: organisation?.hashId
          })
        },
        {
          label: "stock",
          value: getCmpUrl(CMP_STOCK_URL, {
            organisationId: organisation?.hashId
          })
        }
      ]}
      onChange={v => history.push(v)}
      value={location.pathname}
      height={48}
      bg="white"
      data-testid="order-stock-toggle"
    />
  );
}
